import type { IconName } from '@/components/entities/Sprite/Icon';

export interface IconType {
  name: IconName;
  icon: string;
}

export const PAYMENT_ICONS: IconType[] = [
  { name: 'footer-visa', icon: 'footer-visa' },
  { name: 'footer-master-card', icon: 'footer-master-card' },
  { name: 'footer-apple-pay', icon: 'footer-apple-pay' },
  { name: 'footer-google-pay', icon: 'footer-google-pay' },
  { name: 'footer-pay-pal', icon: 'pay-pal' },
  { name: 'footer-cash-app', icon: 'cash-app' },
];

export const MOBILE_SECOND_BLOCK_ICONS: IconType[] = [
  { name: 'footer-pay-pal', icon: 'pay-pal' },
  { name: 'footer-cash-app', icon: 'cash-app' },
  { name: 'footer-crypto-icons', icon: 'mobile-crypto-icon' },
];

export const DESKTOP_SECOND_BLOCK_ICONS: IconType[] = [
  { name: 'BTC', icon: 'BTC' },
  { name: 'ETH', icon: 'ETH' },
  { name: 'USDT-tether', icon: 'USDT-tether' },
  { name: 'another-crypto', icon: 'another-crypto' },
];
